import React, { createContext, useContext, useState, useEffect } from 'react';

const SidebarContext = createContext();

export function SidebarProvider({ children }) {
  // Initialize from localStorage synchronously to prevent layout shift
  const [isCollapsed, setIsCollapsed] = useState(() => {
    if (typeof window !== 'undefined') {
      const savedCollapsed = localStorage.getItem('elydine_sidebar_collapsed');
      return savedCollapsed === 'true';
    }
    return false;
  });
  const [isToggling, setIsToggling] = useState(false);

  const toggleCollapse = () => {
    setIsToggling(true);
    const newCollapsed = !isCollapsed;
    setIsCollapsed(newCollapsed);
    localStorage.setItem('elydine_sidebar_collapsed', newCollapsed.toString());
    // Reset toggling flag after transition
    setTimeout(() => setIsToggling(false), 300);
  };

  const sidebarWidth = isCollapsed ? 80 : 256;

  return (
    <SidebarContext.Provider value={{ isCollapsed, toggleCollapse, sidebarWidth, isToggling }}>
      {children}
    </SidebarContext.Provider>
  );
}

export function useSidebar() {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error('useSidebar must be used within SidebarProvider');
  }
  return context;
}
